import preferences from "apis/preferences";
import { HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";

export interface UserPreferenceDto {
  code: string,
  value: string,
  modifiedDate: Date,
};

export const UserPreferenceCodes = {
  muellerEnterpriseTheme: "MuellerEnterpriseTheme",
  assignmentToolPins: "AssignmentToolPins",
};

export const loadPreference = (preferenceCode: string, successCallback:(preference: UserPreferenceDto) => void, mountedRef: { current: boolean }) => WebApiRequest({
  method: HTTP_GET,
  endpoint: preferences.loadPreference(preferenceCode),
  successCallback,
  mountedRef,
});

export const savePreference = (code: string, value: string, successCallback: () => void,  mountedRef: { current: boolean }) => WebApiRequest({
  method: HTTP_POST,
  endpoint: preferences.savePreference(),
  payload: {
    code: code,
    value: value,
  },
  successCallback,
  mountedRef,
});
